import { render, staticRenderFns } from "./vpage.vue?vue&type=template&id=0aa577e4&scoped=true"
import script from "./vpage.vue?vue&type=script&lang=js"
export * from "./vpage.vue?vue&type=script&lang=js"
import style0 from "./vpage.vue?vue&type=style&index=0&id=0aa577e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa577e4",
  null
  
)

export default component.exports